import React, { Fragment, useEffect, useState, useContext } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import * as extensionsReq from '../../../axios/requests/extensionsReq'
import * as forwardToPhoneReq from '../../../axios/requests/forwardToPhoneReq'
import AlertContext from '../../../context/AlertModelContext/AlertModalContext'

const OmniActionList = (props) => {
    const [t] = useTranslation('common')
    const [forwardPhoneList, setForwardPhoneList] = useState([])
    const [activePhoneNum, setActivePhoneNum] = useState()
    const alertCtx = useContext(AlertContext)


    useEffect(() => {
        const fetchForwardPhoneList = async () => {
            try {
                // debugger;
                const allForwardPhones = await forwardToPhoneReq.getAllToForwardPhones()
                setForwardPhoneList(allForwardPhones)
                try {
                    const activeForwardPhoneObj = await extensionsReq.getCallForwardingAlways()
                    if (activeForwardPhoneObj.active && activeForwardPhoneObj.active === 'true') {
                        const activePhoneFromList = allForwardPhones.find(item => String(item.telephone) === String(activeForwardPhoneObj.forwardToPhoneNumber))
                        if (activePhoneFromList) {
                            setActivePhoneNum(`${activePhoneFromList.name}-${activePhoneFromList.telephone}`)
                        }
                        else {
                            setActivePhoneNum(t('0'))
                        }

                    }
                    else {
                        setActivePhoneNum(t('Without forwarding'))
                    }
                } catch (e) {
                    console.log('getCallForwardingAlways')
                    console.log(e)
                }
            } catch (e) {
                console.log('getAllToForwardPhones')
                console.log(e)
            }
        }
        fetchForwardPhoneList()
    }, [t])

    const forwardPhoneSelectHandler = async (telephone) => {
        try {
            await extensionsReq.setCallForwardingAlways(telephone)
            const activePhoneFromList = forwardPhoneList.find(item => String(item.telephone) === String(telephone))
            if (activePhoneFromList) {
                setActivePhoneNum(`${activePhoneFromList.name}-${activePhoneFromList.telephone}`)
            }
            else {
                setActivePhoneNum(t('Without forwarding'))
            }
            telephone && alertCtx.showAlert(t('success'), t('Forwarding calls to a phone number successfuly configured', { phoneNumber: telephone }), 'sm')
            !telephone && alertCtx.showAlert(t('success'), t('Call forwarding cancelled'), 'sm')
        } catch (e) {
            alertCtx.showAlert(t('fail'), t('Something went wrong please contact with system administrator'), 'sm')
        }
    }
    const dropDownItems = !forwardPhoneList ? [] : forwardPhoneList.map(forwardPhoneObj => <Dropdown.Item key={forwardPhoneObj._id} onClick={() => forwardPhoneSelectHandler(forwardPhoneObj.telephone)} className='dropDownItemSettings' >{forwardPhoneObj.name} - {forwardPhoneObj.telephone}</Dropdown.Item>)
    dropDownItems.unshift(<Dropdown.Item key='without-forwarding' onClick={() => forwardPhoneSelectHandler()} className='dropDownItemSettings' >{t('Without forwarding')}</Dropdown.Item>)

    return (
        <Fragment>
            <li key='400'><p className='dropDownTitle'>{t('Forward call to')}</p></li>
            <li key='412'><Dropdown className='settingDropDown'>{/*drop='right' {this.state.channelFilterSelected}*/}
                <Dropdown.Toggle variant='outline-secondary' className='CustomBtnSettings'>{activePhoneNum}</Dropdown.Toggle>
                <Dropdown.Menu className="CustomMenuSettings">
                    {dropDownItems}
                </Dropdown.Menu>
            </Dropdown>
            </li>
        </Fragment>
    )
}
export default OmniActionList